import { DataList } from '@brighte/form-components';
import { ModifiedApplicationQuote } from '@graphql/types';
import { Accordion, AccordionItem } from '@spark-web/accordion';
import { TextOverflowStrategy } from '@spark-web/text';
import { getPurchaseDetails, getVendorDetails } from './utils';

export const MultiCategoryDetails = ({ quote }: { quote: ModifiedApplicationQuote }) => {
  const multiCategoryQuotes = [quote, ...(quote?.relatedReferrals ?? [])];

  const multiCategoryPurchaseDetails = multiCategoryQuotes.map(q => {
    const purchaseItemsDetails = getPurchaseDetails(q);
    const vendorDetails = getVendorDetails(q);

    return {
      title: purchaseItemsDetails.title,
      items: [
        ...purchaseItemsDetails.items,
        {
          label: 'Vendor',
          value: vendorDetails.title,
          valueOverflowStrategy: 'breakword' as TextOverflowStrategy,
        },
        ...vendorDetails.items,
      ],
    };
  });

  return (
    <Accordion type="single" defaultValue="category-0">
      {multiCategoryPurchaseDetails.map((details, index) => (
        <AccordionItem label={details.title} value={`category-${index}`} key={index}>
          <DataList items={details.items} />
        </AccordionItem>
      ))}
    </Accordion>
  );
};
